<div class="message mb-20" *ngIf="show">
    <div [innerHtml]="message"></div>
    <span class="close clickable" (click)="show = false">
        <!-- <app-icon icon="close-grey" size="xxs"></app-icon> -->
    </span>
</div>